<template>
  <div id="app">
    <!--<img src="211524227.png" style="height:340px;position:absolute;right:0px;top:0px;">-->
    <img
      src="KLIMADAT_logo.png"
      style="height: 40px; position: absolute; right: 10px; top: 10px"
    />
    <a href="https://www.esrihu.hu/" target="_blank">
      <img
        src="gdi_sm.png"
        class="omsz"
        :class="{
          transparentLogo: $store.state.parameterStripe.viewType == 'graphView',
        }"
      />
    </a>
    <a href="https://www.met.hu/" target="_blank">
      <img
        src="omsz_logo_sm.png"
        class="omsz"
        :class="{
          transparentLogo: $store.state.parameterStripe.viewType == 'graphView',
        }"
        style="right: 75px"
      />
    </a>
    <!--<div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <!--<router-view />-->
    <div class="headerClass p-2">
      <!--img src="logo.png" style="height: 50px" /-->
      <!--<h3 class="m-1" style="top: 10px;right: 10px;position: fixed;color: white;">
        <span style="font-size:20px">Klimadat</span> <span style="font-size:12px" > 0.7 </span>
      </h3>-->
      <div
        class="appBranding"
        style="top: 10px; right: 150px; position: fixed; color: white"
      >
        <b-link id="userManual" :href="userManualFileName" target="_blank"
          ><img src="info-circle.svg" style="height: 20px; margin-right: 10px"
        /></b-link>
        <b-tooltip target="userManual">Felhasználói útmutató</b-tooltip>
        <b-link id="email" href="mailto:klimadinamika@met.hu"
          ><img src="email.svg" style="height: 30px; margin-right: 10px"
        /></b-link>
        <b-tooltip target="email">klimadinamika@met.hu</b-tooltip>
        <b-link id="tutorial" target="_blank" :href="tutorialUrl"
          ><img src="youtube.svg" style="height: 30px"
        /></b-link>
        <b-tooltip target="tutorial">Videós segédlet</b-tooltip>
      </div>

      <ParameterStripe
        class="parameterStripe"
        :dateRangeStart="dateRangeStart"
        :dateRangeStart2="dateRangeStart2"
      />
    </div>
    <div id="versioning">
      <b style="opacity: 100% !important">{{ version }}</b>
    </div>
    <b-tabs v-model="activeTab" nav-class="non-displayed" class="tabpos">
      <b-tab title="mapTab" style="height: 100% !important">
        <Map />
      </b-tab>
      <b-tab
        title="graphicTab"
        style="
          height: 100% !important;
          width: 100% !important;
          background-color: white;
        "
      >
        <LineChart
          style="
            height: 85%;
            padding-left: 50px;
            padding-right: 50px;
            padding-top: 50px;
          "
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ParameterStripe from "@/components/ParameterStripe.vue";
import Map from "@/components/Map.vue";
import LineChart from "./components/LineChart";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { config } from "@/config/config.js";
export default {
  name: "App",
  components: {
    LineChart,
    ParameterStripe,
    Map,
    VueSlider,
  },
  data: function () {
    return {
      tabIndex: 0,
      dateRangeStart: 1971,
      dateRangeStart2: 1971,
      dateRangeOptions: {
        dotSize: 14,
        width: "auto",
        height: 4,
        contained: false,
        direction: "ltr",
        data: null,
        dataLabel: "label",
        dataValue: "value",
        min: 1971,
        max: 2071,
        interval: 10,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: "active",
        tooltipPlacement: "top",
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: true,
        dotOptions: void 0,
        dotAttrs: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
    };
  },
  computed: {
    activeTab: {
      get: function () {
        return this.$store.state.parameterStripe.viewType == "mapView" ? 0 : 1;
      },
      set: function () {},
    },
    compare() {
      return this.$store.state.parameterStripe.compare;
    },
    version() {
      return config.version;
    },
    tutorialUrl() {
      return config.youtubeTutorialUrl;
    },
    userManualFileName() {
      return config.userManualFileName;
    },
  },
};
</script>

<style>
#app {
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.non-displayed {
  display: none !important;
}

.tab-content {
  height: 100%;
}
.mybackcolor {
  background-color: #004b88;
}
.headerClass {
  background-color: #fff;
}
.m-1 {
  /*height: 30.75px !important;*/
}

.tabpos {
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
  top: 165px;
}

.vue-slider-ltr .vue-slider-mark-label {
  left: 50% !important;
  -webkit-transform: translateX(-50%) !important;
  transform: translateX(-50%) !important;
  transform: rotate(300deg) !important;
  transform-origin: bottom left !important;
  margin-top: 15px !important;
  margin-left: -5px !important;
  font-size: 1.1em !important;
}

.LayerSwipe .vertical {
  border-left: 1px solid #2e9d9a !important;
  border-right: 1px solid #2e9d9a !important;
  background-color: #2e9d9a !important;
}

.LayerSwipe .vertical .handle {
  background-color: #2e9d9a !important;

  border: 1px solid #2e9d9a !important;
}

.omsz {
  right: 10px;
  bottom: 40px;
  position: fixed !important;
  z-index: 1000;
  height: 56px;
}
.transparentLogo {
  opacity: 0.5;
}
.invertedColor {
  -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
  filter: invert(100%);
}

/*------------------------------------
- COLOR primary
------------------------------------*/

.btn-primary {
  color: #fff;
  background-color: #2e9d9a !important;
  border-color: #2e9d9a !important;
}

.btn-primary:hover {
  color: #fff !important;
  background-color: #25817e !important;
  border-color: #227573 !important;
}

.btn-primary:focus,
.btn-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(46, 157, 154, 0.5) !important;
}

.btn-primary.disabled,
.btn-primary:disabled {
  /*itt módosítani a szürke színt, ha másik kell*/
  color: #fff !important;
  background-color: grey !important;
  border-color: grey !important;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff !important;
  background-color: #227573 !important;
  border-color: #1e6967 !important;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(46, 157, 154, 0.5) !important;
}

.btn-outline-primary {
  color: #2e9d9a;
  background-color: transparent !important;
  border-color: #2e9d9a !important;
}

.btn-outline-primary:hover {
  color: #fff !important;
  background-color: #2e9d9a !important;
  border-color: #2e9d9a !important;
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(46, 157, 154, 0.5) !important;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #2e9d9a !important;
  background-color: transparent !important;
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff !important;
  background-color: #2e9d9a !important;
  border-color: #2e9d9a !important;
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(46, 157, 154, 0.5) !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  border-color: #2e9d9a !important;
  background-color: #2e9d9a !important;
}

.parameterStripe {
  border: 2px solid;
  border-color: #2e9d9a !important;
}

#versioning {
  position: absolute;
  right: 15px !important;
  top: 10px !important;
  z-index: 100 !important;
  font-size: 9px;
  opacity: 0.85;
  /*background-color: white!important;*/
}
>>> .tooltip-inner {
  background-color: white !important;
  color: black;
  border: 1px solid;
  border-color: black;
  font-size: 1.25em;
}
</style>
